const CONTACT_DETAILS = [
  {
    label: "Call Us",
    value: "0120-4335131",
    href: "tel:01204335131",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
      </svg>
    ),
  },
  {
    label: "Email Us",
    value: "info@adityatechno.in",
    href: "mailto:info@adityatechno.in",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
];

export default function CTABanner() {
  return (
    <section
      id="contact"
      aria-labelledby="cta-heading"
      className="relative overflow-hidden bg-orange-500 py-20 px-6"
    >
      {/* Background geometric accents */}
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -top-16 -left-16 w-72 h-72 rounded-full bg-white/10"
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-20 -right-10 w-96 h-96 rounded-full bg-white/10"
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-white/5"
      />

      <div className="relative max-w-5xl mx-auto text-center">

        {/* Eyebrow */}
        <p className="uppercase tracking-widest text-orange-100 text-sm font-semibold mb-4">
          Where Quality Meets Commitment
        </p>

        {/* Heading */}
        <h2
          id="cta-heading"
          className="text-4xl md:text-5xl font-bold text-white leading-tight"
        >
          Partner With Us for Your Next Project
        </h2>

        {/* Sub-text */}
        <p className="mt-5 text-orange-100 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Whether it's a large-scale MEP contract, an electrical infrastructure rollout, or a single-scope fitout — our team is ready to deliver. Reach out and let's get started.
        </p>

        {/* Contact chips */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          {CONTACT_DETAILS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="flex items-center gap-3 bg-white/15 hover:bg-white/25 border border-white/30 text-white rounded-xl px-6 py-3.5 font-medium transition-all duration-300 backdrop-blur-sm"
            >
              <span className="shrink-0">{item.icon}</span>
              <span className="text-sm">
                <span className="block text-orange-100 text-xs uppercase tracking-wider mb-0.5">
                  {item.label}
                </span>
                {item.value}
              </span>
            </a>
          ))}
        </div>

        {/* Primary CTA */}
        <div className="mt-8">
          <a
            href="https://wa.me/919811935791"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-orange-500 hover:bg-orange-50 font-bold px-12 py-4 rounded-xl text-base shadow-lg hover:shadow-xl transition-all duration-300"
          >
            Get in Touch →
          </a>
        </div>

      </div>
    </section>
  );
}
